import { render, staticRenderFns } from "./emissionsStatus01.vue?vue&type=template&id=57836ab3"
import script from "./emissionsStatus01.vue?vue&type=script&lang=js"
export * from "./emissionsStatus01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57836ab3')) {
      api.createRecord('57836ab3', component.options)
    } else {
      api.reload('57836ab3', component.options)
    }
    module.hot.accept("./emissionsStatus01.vue?vue&type=template&id=57836ab3", function () {
      api.rerender('57836ab3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/gas/emissionsStatus01.vue"
export default component.exports